import {SupportedLocales} from '#types/locale.js';

export const apiCredentialsLanguage = {
  [SupportedLocales.EN]: {
    teamAccess: 'Team access',
    selectTeams: 'Select teams',
    teamOptions: 'Available teams',
    noTeams: 'No teams available',
    loadingTeams: 'Loading teams',
    teamHelp:
      'Applies to the GrowthLoop API. New teams must be added explicitly.',
    teamRequired: 'Select at least one team.',
  },
  [SupportedLocales.ES]: {
    teamAccess: 'Acceso a equipos',
    selectTeams: 'Seleccionar equipos',
    teamOptions: 'Equipos disponibles',
    noTeams: 'No hay equipos disponibles',
    loadingTeams: 'Cargando equipos',
    teamHelp:
      'Se aplica a la API de GrowthLoop. Los nuevos equipos deben añadirse explícitamente.',
    teamRequired: 'Seleccione al menos un equipo.',
  },
};
